import React from 'react';
import PropTypes from 'prop-types';

// Components
import { H4 } from '@styled';
import SearchContainer from '@search/SearchContainer';
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import CompanyCardRedesign from '@cards/CompanyCardRedesign';
import CompanyListItemRedesign from '@cards/CompanyListItemRedesign';
import SearchRefinementsExhibitors from '../../_organisms/SearchRefinementsExhibitors';

// Functionality
import { SAVED_COMPANIES_QUERY } from '@general/graphql/company.graph';
import useExhibitorsFromCompaniesFilters from '../../../hooks/algoliaFilters/useExhibitorsFromCompaniesFilters';
import { mapSearchCompanyToProps } from '@general/transforms/company.transform';

const SearchEventExhibitorsAll = ({
    eventCode,
    additionalFilters,
    defaultViewType,
    hitsPerPage,
    NoResultsText,
    parentView,
    showFilters = false,
    showPagingToolbar = true,
    showSearchBox = false,
    showSearchOptions = false,
    updateSearchStateUrl = false,
}) => {
    const { filterString } = useExhibitorsFromCompaniesFilters(eventCode, additionalFilters);

    if (!filterString) {
        return <H4> There are no Exhibitors attending this event yet.</H4>;
    }

    return (
        <SearchModeContext.Provider value={{ showFilters }}>
            <SearchContainer index="companies">
                <Search
                    filters={filterString}
                    hitsPerPage={hitsPerPage}
                    index="companies"
                    defaultViewType={defaultViewType}
                    displayPagingToolbar={showPagingToolbar}
                    displaySearchBox={showSearchBox}
                    displaySearchOptions={showSearchOptions}
                    updateSearchStateUrl={updateSearchStateUrl}
                    refinementComponent={SearchRefinementsExhibitors}
                >
                    <SearchResults
                        cardComponent={CompanyCardRedesign}
                        listItemComponent={CompanyListItemRedesign}
                        index="companies"
                        NoResultsText={NoResultsText}
                        parentView={parentView}
                        parentSubview="Saved Companies"
                        query={SAVED_COMPANIES_QUERY}
                        transformFunc={mapSearchCompanyToProps}
                        typePlural="companies"
                        resultsPerRow={3}
                    />
                </Search>
            </SearchContainer>
        </SearchModeContext.Provider>
    );
};

SearchEventExhibitorsAll.propTypes = {
    eventCode: PropTypes.string,
    additionalFilters: PropTypes.string,
    defaultViewType: PropTypes.string,
    hitsPerPage: PropTypes.number,
    NoResultsText: PropTypes.elementType,
    parentView: PropTypes.string,
    showFilters: PropTypes.bool,
    showPagingToolbar: PropTypes.bool,
    showSearchBox: PropTypes.bool,
    showSearchOptions: PropTypes.bool,
    updateSearchStateUrl: PropTypes.bool,
};

export default SearchEventExhibitorsAll;
